// Single source of truth for the planning micro-graph / legend colours.
// Order matches the RateMicroGraph bar order: Planned → Assigned → Completed →
// Finalized → Invoiced → Excluded. Hexes are the Bravo (BARE) palette.
export const PLANNING_GRAPH_COLORS = [
  { label: 'Planned', color: '#8b94a1' },
  { label: 'Assigned', color: '#f79321' },
  { label: 'Completed', color: '#eecf00' },
  { label: 'Finalized', color: '#a6ce39' },
  { label: 'Invoiced', color: '#6d8237' },
  { label: 'Excluded', color: '#ef4123' },
];

export const planningGraphColorValues = PLANNING_GRAPH_COLORS.map((c) => c.color);
export const planningGraphLabels = PLANNING_GRAPH_COLORS.map((c) => c.label);

export default PLANNING_GRAPH_COLORS;
